export const products = {
	title: "Productos",
	header: {
		search: "Buscar productos",
		edit: "Editar productos en masa",
		delete: "Eliminar productos",
		deleteConfirm: "¿Está seguro que desea eliminar todos los productos seleccionados?",
		massDelete: "Eliminar productos en masa",
		add: "Agregar productos",
	},
	error:
		"no fue posible identificar el producto correspondiente de {{name}}, descargue una nueva hoja de cálculo modelo y tenga cuidado con la columna 'identificador'",
	sucess: "Todos los productos editados con éxito",
	errorIn: "Error en ",
	bottomText: "Todos los cambios realizados aquí afectarán a todos los menús",
};
